// Represents the test web app that uses the AppAuthJS library.
// Copied and adapted from  https://github.com/openid/AppAuth-JS/blob/master/src/app/index.ts
// https://authts.github.io/oidc-client-ts/
//
/* package.json
    "oidc-client-ts": "~3.0.0-beta.10",
*/
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

/* Some interface declarations for Material design lite. */

/* an example open id connect provider */
const openIdConnectUrl = import.meta.env.VITE_FEIDE_AUTH_URL
const clientId = import.meta.env.VITE_FEIDE_CLIENT_ID
const proclusId = import.meta.env.VITE_PROCLUS_CLIENT_ID

let feideClientId = proclusId

const scope =
  'userid userinfo-name groups-edu groups-org openid longterm userid-feide id_token token refresh_token userinfo-photo'

// 'userid profile groups-edu groups-org openid longterm userid-feide id_token token refresh_token userinfo-photo'

let redirectUri = ''
// let silent_redirectUri = ''
if (location.hostname === 'v4leducator.localhost') {
  redirectUri = import.meta.env.VITE_FEIDE_REDIRECT_URI_LOCAL
  // silent_redirectUri = import.meta.env.VITE_FEIDE_SILENT_REDIRECT_URI_LOCAL
  feideClientId = clientId
} else {
  if (location.hostname === 'stage-laerer.v4l.no') {
    redirectUri = import.meta.env.VITE_FEIDE_REDIRECT_URI_STAGE
    // silent_redirectUri = import.meta.env.VITE_FEIDE_SILENT_REDIRECT_URI_STAGE
    feideClientId = clientId
  } else if (location.hostname === 'laerer.v4l.no') {
    redirectUri = import.meta.env.VITE_FEIDE_REDIRECT_URI_PROD
    // silent_redirectUri = import.meta.env.VITE_FEIDE_SILENT_REDIRECT_URI_PROD
    feideClientId = clientId
  } else if (location.hostname === 'stage-laerer.proclus.no') {
    redirectUri = import.meta.env.VITE_FEIDE_REDIRECT_URI_PROCLUS_STAGE
    // silent_redirectUri = import.meta.env
    //   .VITE_FEIDE_SILENT_REDIRECT_URI_PROCLUS_STAGE
    feideClientId = proclusId
  } else if (location.hostname === 'laerer.proclus.no') {
    redirectUri = import.meta.env.VITE_FEIDE_REDIRECT_URI_PROCLUS_PROD
    // silent_redirectUri = import.meta.env.VITE_FEIDE_SILENT_REDIRECT_URI_PROCLUS_PROD
    feideClientId = proclusId
  }
}

console.log('====================== GET OS HOSTNAME : (%s)', location.hostname)
console.log('====================== GET REDIRECT URI  : (%s)', redirectUri)

/*
oauth.Client = {
  client_id: '<FROM_ENV>',
  client_secret:'<FROM_ENV>',
  token_endpoint_auth_method: 'client_secret_basic',
}
*/
export class AppAuth {
  as = null
  code_verifier = null
  code_challenge = null
  authorizationUrl = null
  code_challenge_method = 'S256'
  current_url = null
  client = {}

  code = ''
  state = ''
  userManager = null

  oidcSettings = {
    authority: openIdConnectUrl,
    client_id: feideClientId,
    // client_secret: clientSecret,
    redirect_uri: redirectUri,
    silent_redirect_uri: redirectUri, //silent_redirectUri,
    //      post_logout_redirect_uri: `${os.hostname()}`,
    post_logout_redirect_uri: `${redirectUri}`,
    response_type: 'code',
    scope: scope,
    userStore: new WebStorageStateStore({ store: window.sessionStorage })
  }

  constructor() {
    console.log('AppAuth constructor got called !')
    console.log(this.oidcSettings)
    this.userManager = new UserManager(this.oidcSettings)
  }

  setCodeStatus(code, state) {
    console.log('setCodeStatus got called:')
    console.log('state: ')
    console.log(state)
    this.code = code
    console.log('code: ')
    console.log(this.code)
    this.state = state
  }

  fetchServiceConfiguration() {
    return new Promise((resolve) => {
      console.log('fetchServiceConfiguration got called !')
      resolve('OK')
    }) // promise
  }

  fetchServiceConfigurationToken(code, state) {
    console.log('fetchServiceConfigurationToken got called !', code, state)
    /*
    console.log('code:')
    console.log(code)
    console.log('state:')
    console.log(state)
    */
    return new Promise((resolve) => {
      if (this.userManager) {
        this.userManager
          .signinCallback()
          .then((res) => {
            console.log('====== signinRedirectCallback returned ... (%j)', res)
            if (res) {
              resolve({
                success: true,
                accessToken: res.access_token,
                expiresIn: res.expires_at,
                idToken: res.id_token
              })
            } else {
              resolve({
                success: false,
                error: true,
                errorMsg: 'No user returned from signinCallback'
              })
            }
          })
          .catch((err) => {
            // e.g. 'No matching state found in storage' - must not leave the login hanging
            console.error('***ERROR*** signinCallback failed', err)
            resolve({
              success: false,
              error: true,
              errorMsg: err?.message || String(err)
            })
          })
      } else {
        resolve({ success: false, error: true, errorMsg: 'No USER MANAGER' })
      }
    })
  }

  makeAuthorizationRequest() {
    console.log('====== makeAuthorizationRequest got called ...')
    return new Promise((resolve) => {
      // create a request
      if (this.userManager) {
        this.userManager
          .signinRedirect()
          .then(() => {
            console.log('====== signinRedirectCallback got called ...')
            resolve('ok')
          })
          .catch((err) => {
            console.log('***ERROR*** signinRedirectCallback got called ...')
            console.log(err)
            resolve('error')
          })
      } else {
        resolve('noUserManager')
      }
    }) // promise
  }

  makeRefreshTokenRequest(code) {
    console.log('========= makeRefreshTokenRequest got called ! (' + code + ')')
    return new Promise((resolve) => {
      resolve('ok')
    }) // promise
  }

  makeTokenRequest(code) {
    return new Promise((resolve) => {
      console.log(
        '========= MakeTokenRequest(code) got called ! code:(' + code + ')'
      )
      resolve('ok')
    }) // promise
  }

  loggedIn() {
    return !!this.accessTokenResponse && this.accessTokenResponse.isValid()
  }

  async signOut() {
    // forget all cached token state
    await this.userManager.signoutSilent()
    this.code = null
    this.state = null
    this.accessTokenResponse = undefined
    this.userManager = null
    /*   this.userManager.signOutRedirect({redirectMethod:'replace', redirectTarget: 'self'})
      .then(res => {
        console.log('====== signOutSilent got called ...')
        console.log(res)
      })
      */
  }

  checkForAuthorizationResponse() {
    return new Promise((resolve) => {
      console.log('checkForAuthorizationResponse got called !!')

      resolve('ok')
    }) // promise
  }

  silentSigning() {
    console.log('SILENT SIGNIN GOT CALLED ...')
    console.log(this.userManager)
    return new Promise((resolve, reject) => {
      this.userManager
        .signinSilent()
        .then((res) => {
          console.log('====== silentSigningin got called ...')
          console.log(res)
          resolve(res)
        })
        .catch((err) => {
          console.info(
            '***ERROR*** silentSigningin failed - must login ...',
            err.toString()
          )
          reject(err)
        })
    }) // promise
  }
}
